module.exports = __webpack_public_path__ + "assets/img/Future_Thouvenin.3405ee6f-ps.jpg";